
import { Component, Vue } from 'vue-property-decorator';
import BasePagina from '@/components/base/BasePagina.vue';
import BaseDialog from '@/components/base/BaseDialog.vue';
import BasePesquisa from '@/components/base/BasePesquisa.vue';
import BaseLista from '@/components/base/BaseLista.vue';
import BaseCampos from '@/components/base/BaseCampos.vue';
// Services
import EquipamentoService from '@/services/equipamento.service';
import PostoTrocaService from '@/services/posto-troca.service';
// Models
import { EquipamentoFilter } from '@/shared/models/equipamento/equipamento.filter';
import { EquipamentoInterface } from '@/shared/models/equipamento/equipamento.interface';
import { BaseDialogInterface } from '@/shared/models/base/dialog.interface';
import { PostoTrocaInterface } from '@/shared/models/posto/posto-troca.interface';
// UTILS
import Rules from '@/shared/utils/rules.util';
import Format from '@/shared/utils/format.util';

@Component({
  components: {
    BasePagina,
    BaseDialog,
    BasePesquisa,
    BaseLista,
    BaseCampos,
  },
})
export default class Equipamento extends Vue {
  private rules = Rules;

  public labelBotaoNovo = 'Novo Equipamento';

  public editedItem = {} as EquipamentoInterface;

  public filtro = {} as EquipamentoFilter;

  private listaBoolean = [
    { boolean: true, descricao: 'Sim' },
    { boolean: false, descricao: 'Não' },
  ];

  private getListaBoolean() {
    return this.listaBoolean;
  }

  // Dialog
  public dialogInterface = {
    formTitle: '',
    dialog: false,
    textBotaoPrimario: 'Salvar',
    funcaoPrimaria() {
      //
    },
    fecharModal: this.fecharModalCriarEditar,
    colorBotaoPrimario: 'primary',
  } as BaseDialogInterface;

  // Dialog Alterar Ativação
  public dialogAlterarAtivacao = {
    formTitle: 'Alterar Ativação',
    dialog: false,
    textBotaoPrimario: 'Salvar',
    funcaoPrimaria() {
      //
    },
    fecharModal: this.fecharModalAlterarAtivacao,
    colorBotaoPrimario: 'primary',
  } as BaseDialogInterface;

  // Dialog Excluir Equipamento
  public dialogExcluirEquipamento = {
    formTitle: 'Excluir Equipamento',
    dialog: false,
    textBotaoPrimario: 'Excluir',
    funcaoPrimaria() {
      //
    },
    fecharModal: this.fecharModalExcluir,
    colorBotaoPrimario: 'primary',
  } as BaseDialogInterface;

  // Campos do Dialog
  public readonlyCamposDialog = false;

  public readonlyEditarDialog = false;

  public lista: Array<EquipamentoFilter> = [];

  public headers: Array<Record<string, any>> = [
    {
      text: 'Código', value: 'codigo', align: 'center', sortable: false,
    },
    {
      text: 'Descrição', value: 'descricao', align: 'center', sortable: false,
    },
    {
      text: 'Endereço', value: 'endereco', align: 'center', sortable: false, width: '20%',
    },
    {
      text: 'Percentual de peso', value: 'percentualPeso', align: 'center', sortable: false,
    },
    {
      text: 'Nome Posto de Troca', value: 'nomePontoDeVenda', align: 'center', sortable: false,
    },
    {
      text: 'CNPJ Posto de Troca', value: 'cnpjPontoDeVenda', align: 'center', sortable: false,
    },
    {
      text: 'Ação', value: 'acao', align: 'center', sortable: false, width: '150px',
    },
  ];

  public listaValues = [
    { value: 'cnpjPontoDeVenda', function: this.formatarCNPJ },
    { value: 'percentualPeso', function: (x) => `${Math.trunc((x.percentualPeso * 100))}%` },
  ];

  private formatarCNPJ(eq: EquipamentoFilter) {
    return Format.cnpj(eq.cnpjPontoDeVenda);
  }

  private getFieldText(item: PostoTrocaInterface) {
    if (item.nomeFantasia === null || item.nomeFantasia === undefined) {
      return item.cnpj;
    } if (item.cnpj === null) {
      return item.nomeFantasia;
    }
    return `${item.cnpj} - ${item.nomeFantasia}`;
  }

  public colapses = [
    { titulo: 'Filtragem', nomeSlot: 'pesquisa' },
    { titulo: 'Lista de Equipamento', nomeSlot: 'lista' },
  ];

  public listaCamposPesquisa = [
    {
      text: 'Código',
      type: 'textField',
      value: 'codigo',
      cols: '4',
    },
    {
      text: 'Descrição',
      type: 'textField',
      value: 'descricao',
      cols: '4',
    },
    {
      text: 'Cadastro Ativo',
      type: 'selectField',
      value: 'cadastroAtivo',
      itemText: 'descricao',
      itemValue: 'boolean',
      items: this.getListaBoolean,
      cols: '4',
      clearable: true,
    },
  ];

  public listaAcoes = [
    { tooltip: 'Editar', icon: 'mdi-square-edit-outline', function: this.abrirEditar },
    {
      tooltip: 'Alterar Ativação',
      icon: 'mdi-circle-edit-outline',
      function: this.abrirAlterarAtivacao,
    },
    { tooltip: 'Excluir', icon: 'mdi-delete-outline', function: this.abrirExcluir },
  ];

  // Dialog de Alterar Ativação
  private async abrirAlterarAtivacao(item: EquipamentoInterface) {
    this.dialogAlterarAtivacao.dialog = true;
    this.readonlyEditarDialog = false;
    this.editedItem = await new EquipamentoService().buscarPorId(item.id);
    this.dialogAlterarAtivacao.funcaoPrimaria = this.alterarAtivacao;
  }

  private fecharModalAlterarAtivacao() {
    this.dialogAlterarAtivacao.dialog = false;
    this.editedItem = {} as EquipamentoInterface;
  }

  // Dialog de Editar
  private async abrirEditar(item: EquipamentoInterface) {
    this.dialogInterface.formTitle = 'Editar Equipamento';
    this.dialogInterface.textBotaoPrimario = 'Salvar';
    this.dialogInterface.colorBotaoPrimario = 'primary';
    this.readonlyCamposDialog = false;
    this.readonlyEditarDialog = true;
    this.dialogInterface.funcaoPrimaria = this.atualizar;
    this.editedItem = await new EquipamentoService().buscarPorId(item.id);
    this.editedItem.cnpjPontoDeVenda = Format.cnpj(this.editedItem.cnpjPontoDeVenda);
    if (this.editedItem !== undefined) {
      this.dialogInterface.dialog = true;
    }
  }

  // Dialog de Criar
  private async abrirCriar() {
    this.dialogInterface.formTitle = 'Novo Equipamento';
    this.dialogInterface.textBotaoPrimario = 'Salvar';
    this.readonlyCamposDialog = false;
    this.readonlyEditarDialog = false;
    this.dialogInterface.colorBotaoPrimario = 'primary';
    this.dialogInterface.funcaoPrimaria = this.salvar;
    this.editedItem = {} as EquipamentoInterface;
    this.dialogInterface.dialog = true;
  }

  // Dialog de Excluir
  private async abrirExcluir(item: EquipamentoInterface) {
    this.dialogExcluirEquipamento.formTitle = 'Excluir Equipamento';
    this.dialogExcluirEquipamento.textBotaoPrimario = 'Excluir';
    this.dialogExcluirEquipamento.colorBotaoPrimario = 'warning';
    this.dialogExcluirEquipamento.funcaoPrimaria = this.excluir;
    this.readonlyCamposDialog = true;
    this.readonlyEditarDialog = true;
    this.editedItem = await new EquipamentoService().buscarPorId(item.id);
    this.dialogExcluirEquipamento.dialog = true;
  }

  private fecharModalExcluir() {
    this.dialogExcluirEquipamento.dialog = false;
    this.editedItem = {} as EquipamentoInterface;
  }

  async alterarAtivacao() {
    await new EquipamentoService()
      .alterarAtivacao(this.editedItem.id, this.editedItem.cadastroAtivo).then(
        () => this.pesquisar(this.filtro),
      );
  }

  async pesquisar(filtro: EquipamentoFilter) {
    this.lista = await new EquipamentoService().buscarPorFiltro(filtro);
  }

  async buscarTodos() {
    this.lista = await new EquipamentoService().buscarTodos();
  }

  async salvar() {
    new EquipamentoService().salvar(this.editedItem)
      .then(() => {
        this.fecharModalCriarEditar();
        this.pesquisar(this.filtro);
      });
  }

  async atualizar() {
    new EquipamentoService().atualizar(this.editedItem)
      .then(() => {
        this.fecharModalCriarEditar();
        this.pesquisar(this.filtro);
      });
  }

  async excluir() {
    new EquipamentoService().excluir(this.editedItem.id)
      .then(() => {
        this.fecharModalCriarEditar();
        this.pesquisar(this.filtro);
      });
  }

  private fecharModalCriarEditar() {
    this.dialogInterface.dialog = false;
    this.editedItem = {} as EquipamentoInterface;
  }

  public listaPonto: Array<PostoTrocaInterface> = [];

  async buscarTodosPontos() {
    this.listaPonto = (await new PostoTrocaService().buscarTodos()).map((pdv) => {
      pdv.cnpj = Format.cnpj(pdv.cnpj);
      return pdv;
    });
  }

  mounted() {
    this.buscarTodos();
    this.buscarTodosPontos();
  }
}
